import CmsApi from "../utilities/cms-api";
import CategoryFilter from "../components/category-filter";

export default class Faqs {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-develospment}
	 */
	static getHolderSelectors = () => ['.faq-element'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		const controls = holderElement.querySelectorAll('.category-controls button');
		const categories = holderElement.querySelectorAll('[data-category]');
		controls.forEach(btn => btn.addEventListener('click', (event) => {
			controls.forEach(b => {
				b.classList.toggle('active', b.value === event.currentTarget.value);
			});



			categories.forEach(c => {
				const selected = c.dataset.category === event.currentTarget.value;
				c.classList.toggle('d-none', !selected);
			});
		}));
	}

}
